import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, IconButton } from '@mui/material';
import StopIcon from '@mui/icons-material/Stop';
import AudioWaveform from './AudioWaveform';

function RecordingView({ analyzerNode, onStop }) {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="subtitle2" color="primary" sx={{ mb: 2, fontWeight: 600 }}>
        ● Listening
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
        <AudioWaveform analyzerNode={analyzerNode} isActive />
      </Box>

      <IconButton
        onClick={onStop}
        sx={{
          width: 64,
          height: 64,
          bgcolor: 'error.main',
          color: 'white',
          '&:hover': { bgcolor: 'error.dark' },
        }}
      >
        <StopIcon sx={{ fontSize: 32 }} />
      </IconButton>
      <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 1 }}>
        Tap to stop
      </Typography>
    </Box>
  );
}

RecordingView.propTypes = {
  analyzerNode: PropTypes.shape({
    frequencyBinCount: PropTypes.number,
    getByteFrequencyData: PropTypes.func,
  }),
  onStop: PropTypes.func.isRequired,
};

RecordingView.defaultProps = {
  analyzerNode: null,
};

export default RecordingView;
